import {IServiceFactory} from "../../../service-factory.interface";
import {UnaccompaniedMinorBaseSsr} from "./unaccompanied-minor-base-ssr";

export default class UmfrSsrType extends UnaccompaniedMinorBaseSsr {
    constructor(services: IServiceFactory) {
        super('UMFR', services);
    }
}
